// extracted by mini-css-extract-plugin
module.exports = {"bedOptionsContainer":"bed_options_bedOptionsContainer__2byNU"};